<template>
    <div class="row px-1">
        <!-- Left Side: Main Event Details -->
        <div class="col-12 col-md-7 border-end">
            <div class="row">
                <div class="col-12 mb-1">
                    <label for="event_title" class="form-label d-block w-100 text-start">Title</label>
                    <div class="input-group input-group-merge w-100">
                        <input
                            id="event_title"
                            name="name"
                            type="text"
                            class="form-control"
                            placeholder="Enter Title"
                            v-model="formData.title"
                        />
                    </div>
                </div>

                <div class="col-12 mb-1">
                    <label class="form-label d-block w-100 text-start">Date & Time</label>
                    <div class="row">
                        <div class="col-6">
                            <label for="event_from" class="form-label d-block w-100 text-start">From</label>
                            <input
                                id="event_from"
                                v-model="formData.start_time"
                                name="datetime"
                                type="datetime-local"
                                class="form-control"
                            />
                        </div>
                        <div class="col-6">
                            <label for="event_to" class="form-label d-block w-100 text-start">To</label>
                            <input
                                id="event_to"
                                v-model="formData.end_time"
                                name="datetime"
                                type="datetime-local"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-6 mb-1">
                    <label for="event_assign_to" class="form-label d-block w-100 text-start">Assign To</label>
                    <input
                        id="event_assign_to"
                        type="text"
                        class="form-control"
                        disabled
                        :value="formData.assign_to ? formData.assign_to.name : ''"
                    />
                </div>
                <div class="col-6 mb-1">
                    <label for="event_report_to" class="form-label d-block w-100 text-start">Report To</label>
                    <AsyncSelect
                        id="event_report_to"
                        placeholder="Report To"
                        v-model="formData.report_to"
                        :api-service="fetchContactProfiles"
                        :additional-query="{roles: 'employee', status: 'active'}"
                        label="name"
                    />
                </div>

                <div class="col-12 mb-1">
                    <label for="event_participants" class="form-label d-block w-100 text-start">Participants </label>
                    <AsyncSelect
                        id="event_participants"
                        multiple
                        placeholder="Select participants"
                        v-model="formData.participants"
                        :api-service="fetchContactProfiles"
                        :additional-query="{roles: 'employee', status: 'active'}"
                        label="name"
                    />
                </div>

                <div class="col-6 mb-1">
                    <label for="event_activity" class="form-label d-block w-100 text-start">Organization Activity</label>
                    <AsyncSelect
                        id="event_activity"
                        placeholder="Select Activity"
                        v-model="formData.activity_setup_id"
                        :api-service="fetchActivitySetupEndpoint"
                        label="name"
                        :reduce="item => item.id"
                    />
                </div>

                <div class="col-6 mb-1">
                    <label for="event_deal" class="form-label d-block w-100 text-start"> Deal </label>
                    <AsyncSelect
                        id="event_deal"
                        placeholder="Select Deal"
                        v-model="formData.deal"
                        :api-service="fetchDealNameList"
                        label="name"
                    />
                </div>

                <div class="col-12 text-end mb-1">
                    <button class="btn btn-sm btn-outline-primary" @click="isMoreSelected = !isMoreSelected">
                        {{ isMoreSelected ? 'Less Options' : 'More Options' }}
                    </button>
                </div>

                <template v-if="isMoreSelected">
                    <div class="col-6 mb-1">
                        <label for="event_client" class="form-label d-block w-100 text-start">Client</label>
                        <AsyncSelect
                            id="event_client"
                            placeholder="Client"
                            v-model="formData.client"
                            :api-service="fetchContactProfiles"
                            :additional-query="{roles: 'customer,lead'}"
                            @option:selected="onChangeSelectedClient"
                            label="name"
                        />
                    </div>
                    <div class="col-6 mb-1">
                        <label for="event_tag" class="form-label d-block w-100 text-start">Tag</label>
                        <v-select
                            id="event_tag"
                            multiple
                            placeholder="Select Tag"
                            v-model="formData.tag"
                            :options="tagList"
                            label="name"
                        />
                    </div>

                    <div class="col-6 mb-1">
                        <label for="event_project" class="form-label d-block w-100 text-start">Project</label>
                        <input
                            id="event_project"
                            type="text"
                            class="form-control"
                            disabled
                            :value="formData.project ? formData.project.name : ''"
                        />
                    </div>
                    <div class="col-6 mb-1">
                        <label for="event_project_activity" class="form-label d-block w-100 text-start">Project Activity</label>
                        <input
                            id="event_project_activity"
                            type="text"
                            class="form-control"
                            disabled
                            :value="formData.project_activity ? formData.project_activity.name : ''"
                        />
                    </div>



                    <div class="col-12 mb-1">
                        <label for="event_priority" class="form-label d-block w-100 text-start">Priority</label>
                        <v-select
                            id="event_priority"
                            placeholder="Select Priority"
                            v-model="formData.priority"
                            :options="priorityList"
                            label="name"
                        />
                    </div>

                    <div class="col-12 mb-1">
                        <label for="event_location" class="form-label d-block w-100 text-start">Location / Mode</label>
                        <AsyncSelect
                            id="event_location"
                            placeholder="Select Location"
                            v-model="formData.area_id"
                            :api-service="fetchAreaList"
                            label="name"
                        />
                    </div>

                    <div class="col-12 mb-1">
                        <label for="event_description" class="form-label d-block w-100 text-start">Description</label>
                        <div class="input-group input-group-merge w-100">
                            <textarea
                                id="event_description"
                                v-model="formData.description"
                                name="reference" rows="2"
                                placeholder="Enter Description"
                                class="form-control"
                            ></textarea>
                        </div>
                    </div>

                    <div class="col-12 mb-1">
                        <label class="form-label text-start">Attachment</label>
                        <BlobFileViewer :attachments="formData.attachments" />
                        <FileUpload
                            :is-drag-active="true"
                            button-text="Upload Documents"
                            v-model="formData.attachments"
                        />
                    </div>
                </template>
            </div>
        </div>

        <!-- Right Side: Work Status -->
        <div class="col-12 col-md-5">
            <div class="ps-1">
                <h4 class="fw-bolder">My Work Status</h4>
                <div class="row">
                    <div class="col-12 mb-1">
                        <label for="work_date_event" class="form-label d-block w-100 text-start">Date</label>
                        <input
                            id="work_date_event"
                            name="name"
                            type="date"
                            class="form-control"
                            placeholder="Enter Date"
                            v-model="workStatusFormData.date"
                        />
                    </div>
                    <div class="col-12 mb-1">
                        <label for="work_location_event" class="form-label d-block w-100 text-start">Location</label>
                        <AsyncSelect
                            id="work_location_event"
                            placeholder="Select Location"
                            v-model="workStatusFormData.area_id"
                            :api-service="fetchAreaList"
                            label="label"
                            @option:selected="handleLocationChange"
                        />
                    </div>
                    <div class="col-12 mb-1">
                        <label for="work_hours_event" class="form-label d-block w-100 text-start">Input Hours</label>
                        <input
                            id="work_hours_event"
                            name="name"
                            type="text"
                            class="form-control"
                            placeholder="Enter Hours"
                            v-model="workStatusFormData.hours"
                        />
                    </div>
                    <div class="col-12 mb-1">
                        <label for="work_conveyance_event" class="form-label d-block w-100 text-start">Conveyance Bill</label>
                        <input
                            id="work_conveyance_event"
                            name="name"
                            type="text"
                            class="form-control"
                            placeholder="Enter Conveyance Bill"
                            v-model="workStatusFormData.conveyance"
                        />
                    </div>
                    <div class="col-12 mb-1">
                        <label for="work_description_event" class="form-label d-block w-100 text-start">Description</label>
                        <div class="input-group input-group-merge w-100">
                            <textarea
                                id="work_description_event"
                                v-model="workStatusFormData.description"
                                name="reference" rows="4"
                                placeholder="Enter Work Description"
                                class="form-control"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref, reactive, onMounted} from 'vue';
import { getCurrentDateTime } from '@/services/utils/global.js';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from '@/services/modules/contact'
import handleDropDowns from '@/services/modules/dropdowns'
import {useRoute} from "vue-router";
import FileUpload from "@/components/atom/FileUpload";
import BlobFileViewer from "@/components/atom/BlobFileViewer";
import handleCrm from '@/services/modules/crm/crm'
import handleAdmin from '@/services/modules/admin/admin';
import useDate from '@/services/utils/day';

const {fetchContactProfiles} = handleContact()
const { fetchActivitySetupEndpoint } = handleDropDowns();
const { fetchAreaList, fetchSingleArea } = handleCrm();
const { fetchDealNameList } = handleAdmin();
const { formatToDate } = useDate();

const props = defineProps({
    startDate: String,
    endDate: String,
    tagList: Array,
    priorityList: Array,
    editData: {
      type: Object,
      default: () => ({})
    },
});

const route = useRoute();



const workStatusFormData = reactive({
  id:null,
  area_id: null,
  conveyance: null,
  hours: null,
  date: null,
  description: null
})

const formData = reactive({
    type: 'event',
    assign_to: null,
    report_to: null,
    area_id: null,
    activity_setup_id: null,
    client: '',
    project: '',
    deal: '',
    project_activity: '',
    tag: [],
    priority: null,
    start_time: getCurrentDateTime(props.startDate),
    end_time: getCurrentDateTime(props.endDate),
    title: '',
    description: '',
    attachments: [],
    participants: [],
    route_name:'task-calendar'
});

const isMoreSelected = ref(false);

const resetForm = () => {
  formData.title = '';
  formData.start_time = null
  formData.end_time = null
  formData.description = '';
  formData.assign_to = null;
  formData.area_id = null;
  formData.report_to = null;
  formData.client = '';
  formData.project = '';
  formData.deal = '';
  formData.project_activity = '';
  formData.priority = null;
  formData.participants = [];
  formData.activity_setup_id = null;
  formData.tag = [];
  formData.attachments = [];
  workStatusFormData.area_id = null;
  workStatusFormData.hours = null;
  workStatusFormData.description = null;
  workStatusFormData.date = null;
  workStatusFormData.conveyance = null;
};

function getFormData() {
  return {...formData};
}

function getWorkStatusFormData() {
  return {...workStatusFormData};
}

const onChangeSelectedClient = () => {
  formData.project_activity = null;
  formData.project = null;
}

const handleLocationChange = async (newArea) => {
  if (!newArea || !newArea.id) {
    workStatusFormData.conveyance = 0
    return
  }

  const query = `?company_id=${route.params.companyId}`
  try {
    const area = await fetchSingleArea(newArea.id, query)
    if (area) {
      workStatusFormData.conveyance = area.data.amount
    }
  } catch (error) {
    workStatusFormData.conveyance = 0
  }
}

onMounted(() => {
  workStatusFormData.date = formatToDate(props.startDate);
  if (props.editData && Object.keys(props.editData).length) {
    props.editData.values && props.editData.values.forEach((val) => {
      if (['assigned_to', 'project_id', 'project_activity_id'].includes(val.field_key)) {
        const obj = val.field_value
          ? {
            id: val.field_value_id,
            name: val.field_value.full_name || val.field_value.name || '',
          }
          : null;

        formData[['project_id', 'project_activity_id'].includes(val.field_key) ? val.field_key.replace('_id', '') : 'assign_to'] = obj;

        if (val.field_key === 'project_activity_id' && obj) {
          formData.title = obj.name;
        }
      }
    });
  }
});

defineExpose({
  getFormData,
  getWorkStatusFormData,
  resetForm
});

</script>

<style scoped> 
.border-end {
    border-right: 1px solid #ebe9f1 !important;
}
</style>
